module.exports = __webpack_public_path__ + "instagram.png?425304e1a1230b15d39093cb088d534a";